import styled from "styled-components";

export const MiniControlCenterDefaultBox = styled.div`
  margin: 1rem 0 0 0;
  background: ${props => props.theme.colors.backgroundLight};
  min-height: 240px;
`;
